__turbopack_context__.v({
  "embedStyles": "EmbedNodeView-module-module__BptHbG__embedStyles",
});
